/**
 * Settings module translations
 * Shared namespace for Settings feature across all products
 */

import pages from "./pages";
import tabs from "./tabs";
import buttons from "./buttons";
import labels from "./labels";
import emptyStates from "./emptyStates";
import table from "./table";
import modals from "./modals";

const settings = {
  pages,
  tabs,
  buttons,
  labels,
  emptyStates,
  table,
  modals,
};

export default settings;
